import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { SettingsClassificationTypeResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { ClassificationTypeFormComponent } from '../classification-type-form/classification-type-form.component';
import { ClassificationTypeService } from 'src/app/admin/servicies/classification-type.service';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { Constants } from 'src/app/shared/constants';

@Component({
    selector: 'app-classification-type-list',
    templateUrl: './classification-type-list.component.html',
    styleUrls: ['./classification-type-list.component.sass'],
    standalone: false
})
export class ClassificationTypeListComponent extends BaseComponent implements OnInit {
  items: SettingsClassificationTypeResponseModel[];
  allCollapsed = false;
  showUpdatePODStatus = false;

  constructor(
    private dialogueService: DialogService,
    private service: ClassificationTypeService,
    private settingsService: AdminSettingsService,
    messageService: MessageService
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.loadData();
    this.loadUpdatePODStatusSetting();
  }

  openPopup(item: SettingsClassificationTypeResponseModel) {
    this.dialogueService
      .open(ClassificationTypeFormComponent, {
        showHeader: true,
        closable: true,
        data: item
      })
      .onClose.subscribe((response: any) => {
        if (response) {
          this.loadData();
        }
      });
  }

  delete(classification: SettingsClassificationTypeResponseModel) {
    this.dialogueService
      .open(ConfirmDialogComponent, {
        data: {
          message: `Are you sure you want to delete '${classification.crmClassificationType}'`
        },
        header: 'Confirmation'
      })
      .onClose.subscribe((response: boolean) => {
        if (!response) 
          return;
        this.service.deleteById(classification.crmClassificationTypeId).subscribe((res: any) => {
          this.showSuccessMessage('Classification type has been deleted successfully.');
          this.loadData();
        });
      });
  }

  private loadData() {
    this.loading = true;
    this.service.getAll().subscribe((res: SettingsClassificationTypeResponseModel[]) => {
      this.items = res;
      this.loading = false;
    });
  }

  private loadUpdatePODStatusSetting() {
    this.settingsService.getSettingsByKey(Constants.SettingKeys.UpdatePODStatusClassificationTypeWise).subscribe((res: any) => {
      this.showUpdatePODStatus = res?.responseModel?.schSettingValue?.toLowerCase() === 'true';
    });
  }

  expandCollapseAll() {
    this.allCollapsed = !this.allCollapsed;
    this.items.forEach((t) => {
      t.collapsed = this.allCollapsed;
    });
  }
}
